<template>
  <div class="page dashboard-page">
    <h2 class="page-title">数据看板</h2>
    <el-row :gutter="18" class="stat-row" v-loading="loading">
      <el-col :xl="6" :lg="8" :md="12" :sm="12" :xs="24" v-for="item in statCards" :key="item.key">
        <div class="stat-card" :style="{ background: item.bg }">
          <div class="stat-icon"><i :class="item.icon"></i></div>
          <div class="stat-body">
            <div class="stat-num">{{ stats[item.key] != null ? stats[item.key] : '-' }}</div>
            <div class="stat-label">{{ item.label }}</div>
          </div>
        </div>
      </el-col>
    </el-row>

    <el-row :gutter="18" class="chart-row">
      <el-col :lg="12" :md="24">
        <div class="chart-card">
          <div class="chart-title">近30天巡护趋势</div>
          <div class="chart-placeholder">
            <div class="chart-bar-wrap" v-if="patrolTrend.length">
              <div
                v-for="(item, i) in patrolTrend"
                :key="i"
                class="chart-bar-item"
                :title="item.date + ': ' + item.count + '次'"
              >
                <div class="bar" :style="{ height: barHeight(item.count) + 'px' }"></div>
                <div class="bar-label" v-if="i % 5 === 0">{{ item.date.slice(5) }}</div>
              </div>
            </div>
            <div v-else class="chart-empty">暂无趋势数据</div>
          </div>
        </div>
      </el-col>
      <el-col :lg="12" :md="24">
        <div class="chart-card">
          <div class="chart-title">检测 / 修缮申请状态分布</div>
          <div class="status-dist">
            <div class="dist-group">
              <div class="dist-title">检测申请</div>
              <div class="dist-bars">
                <div v-for="s in testStatusList" :key="s.label" class="dist-row">
                  <span class="dist-label">{{ s.label }}</span>
                  <div class="dist-bar-bg">
                    <div class="dist-bar-fill" :style="{ width: distPercent(s.count, testTotal) + '%', background: s.color }"></div>
                  </div>
                  <span class="dist-count">{{ s.count }}</span>
                </div>
              </div>
            </div>
            <div class="dist-group">
              <div class="dist-title">修缮申请</div>
              <div class="dist-bars">
                <div v-for="s in repairStatusList" :key="s.label" class="dist-row">
                  <span class="dist-label">{{ s.label }}</span>
                  <div class="dist-bar-bg">
                    <div class="dist-bar-fill" :style="{ width: distPercent(s.count, repairTotal) + '%', background: s.color }"></div>
                  </div>
                  <span class="dist-count">{{ s.count }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { fetchDashboard } from '@/api'

export default {
  data() {
    return {
      loading: false,
      stats: {},
      patrolTrend: [],
      testStatusList: [],
      repairStatusList: [],
      statCards: [
        { key: 'wellTotal', label: '泉井总数', icon: 'el-icon-location-outline', bg: 'linear-gradient(135deg,#1c6b53,#2eb67d)' },
        { key: 'userTotal', label: '用户总数', icon: 'el-icon-user-solid', bg: 'linear-gradient(135deg,#0f766e,#14b8a6)' },
        { key: 'guardianTotal', label: '守望者人数', icon: 'el-icon-user', bg: 'linear-gradient(135deg,#1565c0,#42a5f5)' },
        { key: 'claimTotal', label: '泉井认领数', icon: 'el-icon-s-check', bg: 'linear-gradient(135deg,#6a1b9a,#ab47bc)' },
        { key: 'donationTotal', label: '捐赠记录数', icon: 'el-icon-present', bg: 'linear-gradient(135deg,#be185d,#f472b6)' },
        { key: 'patrolTotal', label: '总巡护次数', icon: 'el-icon-map-location', bg: 'linear-gradient(135deg,#0d6e5a,#26c6a2)' },
        { key: 'monthPatrol', label: '本月巡护次数', icon: 'el-icon-date', bg: 'linear-gradient(135deg,#00796b,#4db6ac)' },
        { key: 'integralTotal', label: '已发积分总额', icon: 'el-icon-medal', bg: 'linear-gradient(135deg,#d9822b,#f6b44b)' },
        { key: 'testApply', label: '检测申请数', icon: 'el-icon-document', bg: 'linear-gradient(135deg,#c62828,#ef5350)' },
        { key: 'repairApply', label: '修缮申请数', icon: 'el-icon-s-tools', bg: 'linear-gradient(135deg,#4527a0,#7e57c2)' },
        { key: 'tested', label: '已检测数', icon: 'el-icon-circle-check', bg: 'linear-gradient(135deg,#1b5e20,#66bb6a)' },
        { key: 'repaired', label: '已修缮数', icon: 'el-icon-finished', bg: 'linear-gradient(135deg,#e65100,#ffa726)' }
      ]
    }
  },
  computed: {
    testTotal() { return this.testStatusList.reduce((s, i) => s + (i.count || 0), 0) },
    repairTotal() { return this.repairStatusList.reduce((s, i) => s + (i.count || 0), 0) }
  },
  created() { this.loadData() },
  methods: {
    async loadData() {
      this.loading = true
      try {
        const res = await fetchDashboard()
        this.stats = res || {}
        this.patrolTrend = res.patrolTrend || []
        this.testStatusList = [
          { label: '待检测', count: res.testPending || 0, color: '#e6a23c' },
          { label: '检测中', count: res.testProcessing || 0, color: '#409eff' },
          { label: '可饮用', count: res.tested || 0, color: '#67c23a' },
          { label: '不可饮用', count: res.testClosed || 0, color: '#f56c6c' }
        ]
        this.repairStatusList = [
          { label: '待修缮', count: res.repairPending || 0, color: '#f56c6c' },
          { label: '修缮中', count: res.repairProcessing || 0, color: '#409eff' },
          { label: '已修缮', count: res.repaired || 0, color: '#67c23a' }
        ]
      } catch (e) {
        this.stats = {}
      } finally {
        this.loading = false
      }
    },
    barHeight(count) {
      const max = Math.max(...this.patrolTrend.map(i => i.count), 1)
      return Math.max(4, Math.round((count / max) * 110))
    },
    distPercent(count, total) {
      if (!total) return 0
      return Math.round((count / total) * 100)
    }
  }
}
</script>

<style scoped>
.stat-row { margin-bottom: 4px; }
.chart-row {
  margin-top: 24px;
  display: flex;
  flex-wrap: wrap;
}
.chart-row > [class*="el-col-"] {
  display: flex;
  margin-bottom: 18px;
}
.stat-card {
  border-radius: 16px;
  padding: 20px 20px 18px;
  display: flex;
  align-items: center;
  gap: 16px;
  color: #fff;
  margin-bottom: 18px;
  box-shadow: 0 6px 20px rgba(0,0,0,.10);
}
.stat-icon { font-size: 32px; opacity: .85; }
.stat-num { font-size: 30px; font-weight: 800; line-height: 1.1; }
.stat-label { font-size: 13px; opacity: .88; margin-top: 4px; }
.chart-card {
  background: #fff;
  border-radius: 16px;
  padding: 22px 22px 18px;
  box-shadow: 0 2px 14px rgba(0,0,0,.07);
  min-height: 220px;
  width: 100%;
  display: flex;
  flex-direction: column;
}
.chart-title { font-size: 15px; font-weight: 700; color: #123c2f; margin-bottom: 18px; }
.chart-placeholder { overflow: hidden; flex: 1; display: flex; align-items: flex-end; }
.chart-bar-wrap { display: flex; align-items: flex-end; gap: 3px; height: 120px; width: 100%; }
.chart-bar-item { display: flex; flex-direction: column; align-items: center; flex: 1; }
.bar { width: 100%; background: linear-gradient(#2eb67d, #7eded6); border-radius: 3px 3px 0 0; min-height: 4px; transition: height .3s; }
.bar-label { font-size: 10px; color: #aaa; margin-top: 2px; }
.chart-empty { color: #bbb; text-align: center; padding: 30px 0; font-size: 13px; }
.dist-group { }
.dist-group + .dist-group { margin-top: 16px; }
.dist-title { font-size: 13px; font-weight: 700; color: #555; margin-bottom: 10px; }
.dist-row { display: flex; align-items: center; gap: 8px; margin-bottom: 8px; }
.dist-label { width: 52px; font-size: 12px; color: #666; flex-shrink: 0; }
.dist-bar-bg { flex: 1; height: 12px; background: #f0f2f5; border-radius: 6px; overflow: hidden; }
.dist-bar-fill { height: 100%; border-radius: 6px; transition: width .4s; min-width: 2px; }
.dist-count { width: 36px; text-align: right; font-size: 12px; color: #444; font-weight: 600; flex-shrink: 0; }
</style>
